import { Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'

import { Calendar, Gasang, GreenFootPrint } from '../components/PopUp'

import CalendarIcon from '../assets/images/common/ico_cal.svg'
import CloseIcon from '../assets/images/common/close-icon.svg'
import DownIcon from '../assets/images/common/chevron-down.svg'
import TalkTalkIcon from '../assets/images/main/bookmark12.svg'
// import { calendarData } from '../assets/dummy'
import { bookmarkList, talkList } from '../assets/data'
import { AnimatePresence, motion } from 'framer-motion'
import { userState } from 'stores/userState'
import { useRecoilState, useRecoilValue } from 'recoil'
import { getAnniversaryList } from 'apis/anniversary'
import { Cookies } from 'react-cookie'
import { chatWindowState } from 'stores/chatWindowState'

import { createJwtToken } from 'utils/jwtModule'
import { jwtTokenState } from 'stores/jwtTokenState'

const cookies = new Cookies()
// export const MAIN_URL = 'https://aitalk.cne.go.kr'
// export const CHAT_URL = 'https://aitalk.cne.go.kr/chat'
export const MAIN_URL = 'https://aitalk.cne.go.kr/prompt'
export const CHAT_URL = 'https://aitalk.cne.go.kr'

export default function Main() {
  const [gasangOpen, setGasangOpen] = useState(false)
  const [greenFootPrintOpen, setGreenFootPrintOpen] = useState(false)
  // const [mainPopupOpen, setMainPopupOpen] = useState(false)
  const [calendarOpen, setCalendarOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(0)
  const [isCalendarClose, setIsCalendarClose] = useState(false)
  const [isChatOpen, setIsChatOpen] = useState(false)
  const user = useRecoilValue(userState)
  const [jwtToken, setJwtToken] = useRecoilState(jwtTokenState)

  const iframeRef = useRef(null)
  const iframeRef2 = useRef(null)
  const chatWindowRef = useRef(null)
  const [chatWindow, setChatWindow] = useRecoilState(chatWindowState)
  const [iframeHeight, setIframeHeight] = useState(270)
  const openCalendar = () => {
    setCalendarOpen(true)
  }

  const openPopUp = (setPopUpOpen) => {
    if (!setPopUpOpen) return
    setPopUpOpen(true)
  }

  const handleClickBookmark = (bookmarkItem) => {
    // if (bookmarkItem.id === 8) {
    //   openPopUp(setGasangOpen)
    // } else
    if (bookmarkItem.id === 9) {
      openPopUp(setGreenFootPrintOpen)
    } else if (bookmarkItem.id === 12) {
      dataRef.current = null
      chatWindowRef.current = window.open(CHAT_URL + '?token=' + jwtToken, '_blank')
      chatWindowRef.current.opener = window
    } else {
      window.open(bookmarkItem.link, bookmarkItem.target)
    }
  }
  const todayDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
    // dayOfWeek: new Date(year, month, day).getDay(),
  }
  const dayList = ['일', '월', '화', '수', '목', '금', '토']
  const dayOfWeek = new Date(todayDate.year, todayDate.month - 1, todayDate.day).getDay()

  // const [groupedData, setGroupedData] = useState()
  const [todayEvents, setTodayEvents] = useState()
  const getAnniversaryListApi = async () => {
    const getAnniversaryListRes = await getAnniversaryList()
    console.log(getAnniversaryListRes)
    if (getAnniversaryListRes.error) {
      return
    }
    if (getAnniversaryListRes.data && getAnniversaryListRes.data.anniversaries) {
      const tempGroupedData = getAnniversaryListRes.data.anniversaries.reduce((acc, item) => {
        const { year, month, day } = item
        if (!acc[year]) acc[year] = {}
        if (!acc[year][month]) acc[year][month] = {}
        if (!acc[year][month][day]) acc[year][month][day] = []

        acc[year][month][day].push(item)
        return acc
      }, {})
      // setGroupedData(tempGroupedData)
      setTodayEvents(tempGroupedData[todayDate.year]?.[todayDate.month]?.[todayDate.day])
    }
  }
  useEffect(() => {
    // console.log(window.opener)
    // setMainPopupOpen(true)
    getAnniversaryListApi()
    // eslint-disable-next-line
  }, [])

  const userRef = useRef(user)
  useEffect(() => {
    userRef.current = user
    console.log('user state has changed', user)
  }, [user])

  const dataRef = useRef(null)

  const handleSendMessageIframe = (msg, buttonType) => {
    // console.log(cookies.get('MAJUON_ACCESS_TOKEN'))
    // console.log(userRef.current)
    const data = {
      type: 'SEARCH_SUBMIT_SUCCESS',
      message: msg || '', // 검색어
      name: userRef.current.name, // 사용자 이름
      userType: userRef.current.userType, // 사용자 타입 => [학생: student, 선생님: teacher, 학부모: parent, 교직원: employee]
      school: userRef.current.school, // 학교 이름
      buttonType: buttonType || '',
      accessToken: cookies.get('MAJUON_ACCESS_TOKEN'), // accessToken
    }
    // const iframe = iframeRef2.current
    let chatWindowVal = chatWindowRef.current
    // console.log(chatWindow)
    if (chatWindow.window) {
      console.log('chatWindow.window exists')
      chatWindowVal = chatWindow.window
    }
    // console.log(chatWindow)
    console.log({ ...data })
    // iframe.contentWindow.postMessage({ ...data }, CHAT_URL)
    if (chatWindowVal) {
      console.log('send postMessage to chat window')
      chatWindowVal.postMessage({ ...data }, CHAT_URL)
      dataRef.current = null // reset dataRef after sending message
      if (chatWindow.window) {
        setChatWindow({ window: null })
      }
    }
  }

  const handleMessages = (e) => {
    // console.log(e)
    if (e.origin === CHAT_URL || e.origin === MAIN_URL) {
      console.log(e)
      if (e.data.type === 'SEARCH_SUBMIT') {
        // setIsChatOpen(true)
        if (e.data.message) {
          dataRef.current = e.data
          console.log(dataRef.current)
        }
        const data = {
          type: 'SEARCH_SUBMIT_SUCCESS',
          message: dataRef.current?.message || '', // 검색어
          name: userRef.current.name, // 사용자 이름
          userType: userRef.current.userType, // 사용자 타입 => [학생: student, 선생님: teacher, 학부모: parent, 교직원: employee]
          school: userRef.current.school, // 학교 이름
          buttonType: dataRef.current?.buttonType || '',
          accessToken: cookies.get('MAJUON_ACCESS_TOKEN'), // accessToken
        }
        const newJwtToken = createJwtToken(data)
        chatWindowRef.current = window.open(CHAT_URL + '?token=' + newJwtToken, '_blank')
        chatWindowRef.current.opener = window
      } else if (e.data.type === 'IFRAME_READY') {
        handleSendMessageIframe(dataRef.current?.message, dataRef.current?.buttonType)
      }
    }
  }

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIframeHeight(270)
    } else if (window.innerWidth < 851) {
      setIframeHeight(180)
    } else {
      setIframeHeight(151)
    }
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)
    window.addEventListener('message', handleMessages)
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('message', handleMessages)
    }
    // eslint-disable-next-line
  }, [chatWindow.window])

  useEffect(() => {
    // disable body scroll when chat is open
    if (isChatOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isChatOpen])

  useEffect(() => {
    const data = {
      type: 'SEARCH_SUBMIT_SUCCESS',
      message: dataRef.current?.message || '', // 검색어
      name: userRef.current.name, // 사용자 이름
      userType: userRef.current.userType, // 사용자 타입 => [학생: student, 선생님: teacher, 학부모: parent, 교직원: employee]
      school: userRef.current.school, // 학교 이름
      buttonType: dataRef.current?.buttonType || '',
      accessToken: cookies.get('MAJUON_ACCESS_TOKEN'), // accessToken
    }
    const newJwtToken = createJwtToken(data)
    setJwtToken(newJwtToken)
    console.log('set New JWT Token:', newJwtToken)
    // eslint-disable-next-line
  }, [
    dataRef.current,
    userRef.current,
    userRef.current.name,
    userRef.current.userType,
    userRef.current.school,
    user,
  ])

  return (
    <div className='wrapper relative'>
      {/* 메인 이벤트 팝업 */}
      {/* {mainPopupOpen && (
        <MainPopup
          setModalOpen={setMainPopupOpen}
          chatWindowRef={chatWindowRef}
          dataRef={dataRef}
        />
      )} */}
      <div className='flex flex-col h-full'>
        <div className='flex flex-col items-center xl:min-h-[215px] justify-center'>
          {/* calendar */}
          {!isCalendarClose && (
            <div className=' w-full flex items-start xl:items-center justify-between p-[15px] xl:px-20 xl:py-10 bg-[#f5f5f5] border-solid border-b-[1px] border-default-border'>
              <div className='flex items-start xl:items-center gap-10 text-[16px] xl:flex-row flex-col'>
                <div className='flex gap-10'>
                  <p className='text-default-black'>{`${todayDate.month}월 ${todayDate.day}일(${dayList[dayOfWeek]})`}</p>
                  <img
                    onClick={openCalendar}
                    className='cursor-pointer'
                    src={CalendarIcon}
                    alt=''
                  />
                </div>
                {todayEvents ? (
                  <div className='flex flex-col sm:gap-10 sm:flex-row'>
                    <p className='text-default-black'>{todayEvents[0].name}: </p>
                    <p className='flex text-default-header'>
                      {todayEvents[0].description}{' '}
                      <span className={`${todayEvents.length > 1 ? 'block' : 'hidden'}`}>
                        외 {todayEvents.length - 1}건
                      </span>
                    </p>
                  </div>
                ) : (
                  <div className='text-default-black'>오늘의 일정이 없습니다.</div>
                )}
              </div>
              <img
                src={CloseIcon}
                alt=''
                onClick={() => setIsCalendarClose((prev) => !prev)}
                className='cursor-pointer'
              />
              {calendarOpen && <Calendar setModalOpen={setCalendarOpen} />}
            </div>
          )}
          {/* bookmarkList */}
          {/* bookmarkIndex === 7 && openPopUp(setGasangOpen)
                      bookmarkIndex === 8 && openPopUp(setGreenFootPrintOpen) */}
          <div className='items-center justify-center hidden py-40 xl:flex gap-30 bg-default-white'>
            {bookmarkList.map((bookmarkItem, bookmarkIndex) => (
              <div key={bookmarkIndex}>
                <div
                  onClick={() => {
                    handleClickBookmark(bookmarkItem)
                  }}
                  className='flex flex-col items-center justify-center gap-10 cursor-pointer'
                >
                  <div className='p-16 rounded-10 bg-[#f5f5f5] flex items-center justify-center'>
                    {bookmarkItem.id === 12 ? (
                      <img className='w-30 h-30' src={TalkTalkIcon} alt='' />
                    ) : (
                      <img className='w-30 h-30' src={bookmarkItem.logo} alt='' />
                    )}
                  </div>
                  <p className='text-[12px] text-default-header'>{bookmarkItem.title}</p>
                </div>
                {/* {bookmarkItem.popUp} */}
                {bookmarkItem.id === 8 && gasangOpen && <Gasang setModalOpen={setGasangOpen} />}
                {bookmarkItem.id === 9 && greenFootPrintOpen && (
                  <GreenFootPrint setModalOpen={setGreenFootPrintOpen} />
                )}
              </div>
            ))}
          </div>
        </div>
        {/* talkList */}
        <div className='min-h-[420px] flex-1 w-full'>
          <div
            className={`${
              isHovered === 0 ? 'bg-[#cddfe8]' : 'bg-[#e2e8ed]'
            } flex justify-center py-20 xl:py-0 items-center xl:items-end relative  px-[15px] xl:px-0 lg:h-full w-full`}
          >
            {talkList.map((talkItem, talkIndex) => (
              <div
                key={talkIndex}
                className={`${
                  isHovered === talkIndex ? 'hidden xl:block h-full w-full' : 'hidden'
                }`}
              >
                <img
                  className='object-cover w-full h-full'
                  src={isHovered === talkIndex && talkItem.background}
                  alt=''
                />
              </div>
            ))}
            <div className='flex flex-col items-center justify-center w-full h-full max-w-[570px] lg:max-w-full gap-10 xl:gap-0 xl:items-end xl:absolute xl:bottom-0 lg:grid lg:grid-cols-3 xl:flex-row xl:max-w-[1200px]'>
              {talkList.map((talkItem, talkIndex) => (
                <div
                  key={talkIndex}
                  className='flex flex-col items-center justify-center w-full h-full xl:items-end xl:justify-end group'
                  onMouseEnter={() => setIsHovered(talkIndex)}
                >
                  {isHovered !== talkIndex && (
                    <div
                      className='w-[400px] h-[40px] xl:flex items-center justify-center xl:group-hover:hidden hidden'
                      style={{ backgroundColor: talkItem.bgColor }}
                    >
                      <p className='text-default-white text-[20px]'>{talkItem.title}</p>
                    </div>
                  )}
                  <div
                    className={`xl:duration-300 xl:transition-all overflow-hidden ${
                      isHovered === talkIndex ? 'xl:h-full ' : 'xl:h-0'
                    } rounded-[15px] xl:rounded-none  items-center justify-center text-default-white w-full xl:w-[400px] py-20 xl:py-0 flex flex-col lg:h-full gap-20`}
                    style={{ backgroundColor: talkItem.hoverColor }}
                  >
                    <p className='text-[28px] flex items-center justify-center'>{talkItem.title}</p>
                    <div className='grid w-full grid-cols-2 grid-rows-2 gap-10 px-10'>
                      {talkItem.content.map((contentItem, contentIndex) => (
                        <Link
                          key={contentIndex}
                          to={contentItem.link}
                          target='_blank'
                          className={`${
                            talkIndex === 0 && contentIndex === 0 ? 'col-span-2' : null
                          } flex text-default-white items-center justify-center h-60 border-solid border-[1px] rounded-10 border-[rgba(255,255,255,.5)] gap-30 w-full hover:bg-[rgba(255,255,255,.8)] hover:text-default-black`}
                        >
                          <i className={`${contentItem.logo}`} alt=''></i>
                          <p className='text-[14px] xl:text-[16px] whitespace-pre-wrap'>
                            {contentItem.name}
                          </p>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* iframe */}
        <div>
          <iframe
            ref={iframeRef}
            allow='microphone;clipboard-write;clipboard-read;'
            sandbox='allow-scripts allow-popups allow-same-origin allow-forms allow-modals allow-popups-to-escape-sandbox allow-downloads'
            title='clabi_iframe'
            className='transition-all duration-500 overflow-y-hidden'
            src={MAIN_URL + '?userType=' + user.userType}
            width={'100%'}
            scrolling='no'
            height={iframeHeight}
            style={{
              width: '100%',
              height: iframeHeight,
              border: 'none',
              display: 'block',
            }}
          ></iframe>
        </div>
      </div>
      <AnimatePresence>
        {isChatOpen && (
          <motion.div
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: '100%', opacity: 0 }}
            transition={{ duration: 0.5, y: { type: 'spring', bounce: 0 } }}
            className={`fixed top-48 left-0 right-0 w-full h-[calc(100%-48px)] bg-white`}
          >
            <iframe
              ref={iframeRef2}
              title='clabi_chat_iframe'
              allow='microphone;clipboard-write;clipboard-read;'
              sandbox='allow-scripts allow-popups allow-same-origin allow-forms allow-modals allow-popups-to-escape-sandbox allow-downloads'
              src={CHAT_URL + '?userType=' + user.userType}
              width={'100%'}
              height={'100%'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 100,
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
              }}
            ></iframe>
            <button
              onClick={() => {
                setIsChatOpen(false)
              }}
              className='absolute shadow-sm -top-48 left-0 h-48 w-full right-0 flex items-center justify-center bg-gray-50 hover:bg-gray-100'
            >
              <div className='flex items-center justify-center gap-10 text-[#004998]'>
                <p className='text-[16px]'>대화 닫기</p>
                <img src={DownIcon} alt='' className='mt-4' />
              </div>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
